/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import GroupMembershipStatusOption from "data/Prod/MembershipStatus.json"; // Assuming this file exists or needs to be created/adapted
import { reactSelectStyle } from "Config/Config";

const AddNewGroupPartnerModal = ({
  roleList,
  afterCloseModalHandler,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  const { t } = useTranslation();

  const params = useParams();

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [companyInput, setCompanyInput] = useState("");
  const [companyOptions, setCompanyOptions] = useState([]);
  const [companyValue, setCompanyValue] = useState(null);
  const [companyId, setCompanyId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberShipStatusValue, setMemberShipStatusValue] = useState(null);
  const [memberShipData, setmemberShipData] = useState(null);
  const [errorMessage, seterrorMessage] = useState("");
  const [errors, setErrors] = useState({});

  const [isAdding, setIsAdding] = useState(false);

  //** Function for Validation */
  const validateForm = () => {
    const newErrors = {};
    if (!companyValue) {
      newErrors.company = t("Please select a company.");
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //function for get user details
  const getCompanyList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_COMPANY_LIST +
        `?filtername=${companyInput}&roleslug=${userInfo.role.name}`;

      const response = await getData(requestUrl);

      if (response.status) {
        if (response.data.length > 0) {
          setCompanyOptions(response.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for get user input
  const companyInputHandler = (val) => {
    setCompanyInput(val);
    seterrorMessage("");
    if (errors.company) {
      setErrors((prev) => ({ ...prev, company: "" }));
    }
  };

  //function user Selection
  const companySelectionHandler = (val) => {
    seterrorMessage("");
    if (val) {
      setCompanyValue(val);
      setUserEmail(val.email);
      setCompanyId(val.value);
    } else {
      setCompanyValue(null);
      setCompanyId(null);
      setUserEmail("");
      setCompanyOptions([]);
    }
    if (errors.company) {
      setErrors((prev) => ({ ...prev, company: "" }));
    }
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    if (val) {
      setRoleValue(val);
      setRoleData(val.value);
      seterrorMessage("");
    } else {
      setRoleValue(null);
      setRoleData(null);
    }
    if (errors.role) {
      setErrors((prev) => ({ ...prev, role: "" }));
    }
  };

  //function for select memebership status
  const memberShipStatusSelectionHandler = (val) => {
    if (val) {
      setMemberShipStatusValue(val);
      setmemberShipData(val.value);
      seterrorMessage("");
    } else {
      setMemberShipStatusValue(null);
      setmemberShipData(null);
    }
  };

  //function for add group member
  const addGroupSponsorHandler = async () => {
    if (!validateForm()) {
      setMessageType("error");
      setAlertMessage("Please fill up the required fields");
      seterrorMessage(t("Please fill up the required fields"));
      return;
    }

    try {
      setIsAdding(true);

      let groupMemberData = {
        company: companyId,
        group: params.id ? params?.id : null, // Changed from event to group
        role: roleData ?? null,
        useremail: userEmail,
        moderatorstatus: memberShipData,
        memberstatus: "1",
      };

      console.log("groupMemberData---->", groupMemberData);

      let requestUrl =
        url.API_BASE_URL + url.API_ADD_NEW_GROUP_COMPANY; // Changed API endpoint

      const response = await postData(requestUrl, groupMemberData);

      setIsAdding(false);

      console.log(response);

      if (response.status) {
        resetHandler();

        //hide member modal
        let bootstrapModal = document.querySelector("#addGroupCompany");
        let modal = bootstrap.Modal.getInstance(bootstrapModal);
        modal.hide();

        //call member list api function
        afterCloseModalHandler();
      } else {
        seterrorMessage(response.message);
      }
    } catch (error) {
      console.log(error.message);
    }
    setShowAlert(true);
  };

  //function for reset
  const resetHandler = () => {
    setCompanyValue(null);
    setCompanyOptions([]);
    setRoleValue(null);
    setRoleData(null);
    setCompanyInput("");
    setCompanyId(null);
    setUserEmail("");
    seterrorMessage("");
    setErrors({});
    for (let memberStatus of GroupMembershipStatusOption) {
      if (memberStatus.value === "1") {
        memberShipStatusSelectionHandler(memberStatus);
      }
    }
  };

  useEffect(() => {
    if (companyInput.length > 1) {
      getCompanyList();
    }
  }, [companyInput]);

  const optionsToShow = companyOptions.length > 0 ? companyOptions : [];

  useEffect(() => {
    for (let memberStatus of GroupMembershipStatusOption) {
      if (memberStatus.value === "1") {
        memberShipStatusSelectionHandler(memberStatus);
      }
    }
  }, []);

  // Custom styles for Select (Company) to show red border on error
  const companySelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor: errors.company ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.company ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  // Custom styles for Select (Role) to show red border on error
  const roleSelectCustomStyles = {
    control: (base) => ({
      ...base,
      borderColor: errors.role ? "#dc3545" : "#ced4da",
      "&:hover": {
        borderColor: errors.role ? "#dc3545" : "#ced4da",
      },
      borderRadius: "7px",
      padding: "3px",
      minHeight: "40px",
      boxShadow: "none",
    }),
  };

  return (
    <div
      className="modal fade"
      id="addGroupCompany" /* Changed modal ID */
      tabIndex="-1"
      aria-labelledby="addMemberLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
            <div className="d-flex align-items-center gap-3">
              <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
                <span className="material-symbols-outlined text-primary fs-5 icon-md">
                  apartment
                </span>
              </div>
              <div>
                <h3
                  className="modal-title fw-bold text-white mb-0"
                  id="addMemberLabel"
                >
                  {t("Add New Company")}
                </h3>
                <p className="text-white fs-sm mb-0">
                  {t("Invite new companies to your group")} {/* Changed text */}
                </p>
              </div>
            </div>
            <button
              type="button"
              className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
              <form onSubmit={(e) => e.preventDefault()}>
                {/* ----- user select section start ----- */}
                <div className="form-group mb-4">
                  <label
                    htmlFor="memberName"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Company (search by name)")}
                  </label>

                  <Select
                    isClearable
                    styles={companySelectCustomStyles}
                    className="w-100"
                    placeholder={t("Search by company name")}
                    options={optionsToShow}
                    value={companyValue}
                    onChange={(val) => {
                      companySelectionHandler(val);
                    }}
                    onInputChange={(val) => {
                      companyInputHandler(val);
                    }}
                  />
                  {errors.company && (
                    <div className="invalid-feedback d-block">
                      {errors.company}
                    </div>
                  )}
                </div>
                {/* ----- user select section end ----- */}

                {/* ----- role select section start ----- */}
                {/* <div className="form-group mb-4">
                  <label
                    htmlFor="role"
                    className="d-block fs-sm fw-semibold mb-2"
                  >
                    {t("Role")}
                  </label>

                  <Select
                    isClearable
                    styles={roleSelectCustomStyles}
                    className="w-100"
                    placeholder={t("Select role")}
                    options={roleList}
                    value={roleValue}
                    onChange={(val) => roleSelectionHandler(val)}
                  />
                  {errors.role && (
                    <div className="invalid-feedback d-block">
                      {errors.role}
                    </div>
                  )}
                </div> */}
                {/* ----- role select section end ----- */}

                {/* ----- status select section start ----- */}
                {/* <div className="form-group mb-4">
                <label
                  htmlFor="role"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Membership Status")}
                </label>

                <Select
                  className="w-100"
                  placeholder={t("Select status")}
                  options={GroupMembershipStatusOption}
                  value={memberShipStatusValue}
                  onChange={(val) => memberShipStatusSelectionHandler(val)}
                />
              </div> */}
                {/* ----- status select section end ----- */}

                {/* ----- button section start ----- */}
                <div className="action d-flex justify-content-end pt-3 border-top mt-auto">
                  <button
                    type="button"
                    className="btn btn-primary d-flex align-items-center gap-2"
                    onClick={addGroupSponsorHandler}
                    disabled={isAdding ? true : false}
                    style={{
                      cursor: isAdding ? "not-allowed" : "pointer",
                    }}
                  >
                    {isAdding ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        {t("Adding...")}
                      </>
                    ) : (
                      <>
                        <span className="material-symbols-outlined me-1">
                          apartment
                        </span>{" "}
                        {t("Add Company")}
                      </>
                    )}
                  </button>
                </div>
                {/* ----- button section end ----- */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewGroupPartnerModal;
